__turbopack_context__.v({
  "africa": "LocationOverview-module__czwVUa__africa",
  "asia": "LocationOverview-module__czwVUa__asia",
  "clearAllFilters": "LocationOverview-module__czwVUa__clearAllFilters",
  "continent": "LocationOverview-module__czwVUa__continent",
  "country": "LocationOverview-module__czwVUa__country",
  "europe": "LocationOverview-module__czwVUa__europe",
  "filters": "LocationOverview-module__czwVUa__filters",
  "frameParent": "LocationOverview-module__czwVUa__frameParent",
  "imageIcon": "LocationOverview-module__czwVUa__imageIcon",
  "location": "LocationOverview-module__czwVUa__location",
  "locationFilter": "LocationOverview-module__czwVUa__locationFilter",
  "locationSelectOptions": "LocationOverview-module__czwVUa__locationSelectOptions",
  "locationSelectOptionsIndent": "LocationOverview-module__czwVUa__locationSelectOptionsIndent",
  "locationsSelectWrapper": "LocationOverview-module__czwVUa__locationsSelectWrapper",
  "minus": "LocationOverview-module__czwVUa__minus",
  "moduleWrapper": "LocationOverview-module__czwVUa__moduleWrapper",
  "northAmerica": "LocationOverview-module__czwVUa__northAmerica",
  "outerWrapper": "LocationOverview-module__czwVUa__outerWrapper",
  "plus": "LocationOverview-module__czwVUa__plus",
  "regionNorthAmerica": "LocationOverview-module__czwVUa__regionNorthAmerica",
  "resultsGroup": "LocationOverview-module__czwVUa__resultsGroup",
  "resultsWrapper": "LocationOverview-module__czwVUa__resultsWrapper",
  "root": "LocationOverview-module__czwVUa__root",
  "scroll": "LocationOverview-module__czwVUa__scroll",
  "selectBoxCheck": "LocationOverview-module__czwVUa__selectBoxCheck",
  "selectBoxExpand": "LocationOverview-module__czwVUa__selectBoxExpand",
  "subLocationsWrapper": "LocationOverview-module__czwVUa__subLocationsWrapper",
});
